export async function getProductByHandle(productHandle) {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
        throw new Error('Error getting product.');
    }
    else {
        return await response.json();
    }
}
export function getColorwayIdentifierByProduct(product) {
    let colorway = null;
    if (product) {
        const variants = product.variants;
        if (variants && variants.length) {
            const sku = variants[0].sku;
            if (sku) {
                colorway = sku.slice(0, 8);
            }
        }
    }
    return colorway;
}
export function toProductGid(id) {
    return `gid://shopify/Product/${id}`;
}
export function toProductVariantGid(id) {
    return `gid://shopify/ProductVariant/${id}`;
}
